export const PPT_FILE_EXTEND = [
    '.ppt',
    '.pptx',
];

export const PPT_MIME_TYPE = [
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
];

type FileLike = Pick<File, 'type' | 'name'>;

// eslint-disable-next-line arrow-body-style
export const isSupportPPTType = ({ type, name }: FileLike) => {
    // window 注册表可能被三方应用修改，导致 .ppt/.pptx 文件的 content-type 不符合预期
    // 因此后缀检查 与 mimeType 检查满足其一就认为可以上传
    return PPT_FILE_EXTEND.some(ext => name.endsWith(ext))
        || PPT_MIME_TYPE.includes(type);
};
